<script>
import MultitabPicker from '~/components/common/multitab-picker';
import debounce from 'lodash/debounce';
import { CancelToken } from 'axios';
// Constants
import {
    HOTEL_SUGGESTION_DEMANDED,
    HOTEL_SUGGESTION,
} from '~endpoints';

export default {
    extends: MultitabPicker,

    data () {
        return {
            fetchedDestinations: null,
            isUserTyped: false,
            demandedDestinations: null,
            typeToTabMap: {
                City: 'شهر',
                Hotel: 'هتل',
            },
        };
    },

    computed: {
        tabs () {
            const typeToTitleMap = {
                City: 'هتل‌های خارجی',
                DomesticCity: 'هتل‌های داخلی',
            };
            return !this.isUserTyped
                ? (this.fetchedDestinations || []).map(destination => typeToTitleMap[destination.type])
                : (this.$route.path === '/hotel/search/results' ? [this.typeToTabMap.City] : [this.typeToTabMap.City, this.typeToTabMap.Hotel]);
        },

        options () {
            const r = this.fetchedDestinations;
            const tabIndex = this.tabs.indexOf(this.selectedTab);
            if (!r || tabIndex === -1) return [];
            const options = (r[tabIndex].result || []);
            // title, subtitle for picker
            // name, id, type for search
            return options.map(el => ({
                ...el,
                title: el.name,
                subtitle: '',
                id: el.id,
                hotelType: r[tabIndex].type,
            }));
        },
    },

    mounted () {
        this.fetchDestinations();
    },

    methods: {

        onSearchChange (query) {
            this.isUserTyped = !!query;
            this.searchQuery(query);
        },

        fetchDestinations () {
            this.loading = true;
            return this.$axios.$get(HOTEL_SUGGESTION_DEMANDED)
                .then(response => {
                    this.loading = false;
                    this.fetchedDestinations = response.filter(destination => !(destination.type === 'Hotel'));
                    this.demandedDestinations = this.fetchedDestinations;
                })
                .catch(err => {
                    this.loading = false;
                    this.fetchedDestinations = null;
                    console.error(err); // eslint-disable-line no-console
                });
        },

        searchQuery: debounce(function (query) {
            // Cancel old requests
            if (this.searchQueryRequestSource) {
                this.searchQueryRequestSource.cancel();
            }

            // Fast stop, if query length is less than 1
            const queryLength = (query || '').length;
            if (queryLength === 0) {
                this.fetchedDestinations = this.demandedDestinations;
                return;
            }
            if (queryLength < 2) {
                return;
            }
            this.searchQueryRequestSource = new CancelToken.source(); // eslint-disable-line new-cap
            this.loading = true;
            return this.$axios.$get(`${HOTEL_SUGGESTION}/${query}`, { cancelToken: this.searchQueryRequestSource.token })
                .then(response => {
                    this.loading = false;
                    if (this.$route.path === '/hotel/search/results') {
                        this.fetchedDestinations = response.result.filter(destination => !(destination.type === 'Hotel'));
                    } else {
                        this.fetchedDestinations = response.result;
                    }
                    for (let i = 0; i < this.fetchedDestinations.length; i++) {
                        if (this.fetchedDestinations[i].result.length) {
                            this.selectedTab = this.typeToTabMap[this.fetchedDestinations[i].type];
                            break;
                        } else {
                            this.$gtm.sendGTMEvent({
                                event: 'event',
                                eventCategory: 'Hotel monitoring',
                                eventAction: 'Hotel',
                                eventLabel: `${query}, not found`,
                            });
                        }
                    }
                })
                .catch(err => {
                    this.loading = false;
                    if (!err.__CANCEL__) {
                        this.fetchedDestinations = null;
                    }
                });
        }, 200),
    },
};
</script>
